import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-funfacts-style-four',
  templateUrl: './funfacts-style-four.component.html',
  styleUrls: ['./funfacts-style-four.component.scss']
})
export class FunfactsStyleFourComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
